import React, { Component } from 'react';
import autobind from 'react-autobind';
import translate from 'app/translations';
import {
  Row, Col, Button, Carousel,
} from 'antd';
import navigate from 'utils/navigate';

import './Welcome.scss';

import eaLogo from 'assets/images/EA-Pin.png';

import landing1 from 'assets/images/landing-1.jpg';
import landing2 from 'assets/images/landing-2.jpg';
import landing3 from 'assets/images/landing-3.jpg';

export class Welcome extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  render() {
    return (
      <div className="card-container box-shadow welcome">
        <div className="responsive-border">
          <Row>
            <Col md={24} lg={24} xl={12} className="align-center">
              <h1 className="m-b-16">
                {this.t('Welcome.mainHeading')}
                <strong>
                  {this.t('Welcome.mainHeadingEmphasized')}
                </strong>
              </h1>
              <div className="logo-wrap">
                <div className="logo-text">{(new Date()).getFullYear()}</div>
                <img
                  alt="extraoridinary appraisers"
                  src={eaLogo}
                />
              </div>
              <h2 className="orange-text m-tb-16">
                <strong>
                  {this.t('Welcome.subHeading')}
                </strong>
              </h2>
              <Button
                className="m-t-16"
                type="primary"
                htmlType="button"
                onClick={() => { navigate('/agent-register'); }}
              >
                {this.t('Welcome.callToActionButton')}
              </Button>
            </Col>
            <Col md={24} lg={24} xl={12} className="desktop-only">
              <div className="carousel">
                <Carousel autoplay>
                  <img
                    alt={this.t('Welcome.carousel.landing1')}
                    src={landing1}
                  />
                  <img
                    alt={this.t('Welcome.carousel.landing2')}
                    src={landing2}
                  />
                  <img
                    alt={this.t('Welcome.carousel.landing3')}
                    src={landing3}
                  />
                </Carousel>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default Welcome;
